import OkC from "shared/util/OkcApi";

export default {
	submitRegistration({ email, password, tspRefreshToken }) {
		const data = {
			email,
			password,
		};

		if (tspRefreshToken) {
			data.tsp_refresh_token = tspRefreshToken;
		}

		return OkC.post("/signup/email", { api: 1, data });
	},

	recordStartOnboarding() {
		return OkC.post("/signup/start", {
			api: 1,
		});
	},

	// DEPRECATED - remove when facebook signin removed
	submitFacebookSignup(facebookToken) {
		const data = { facebook_access_token: facebookToken };

		return OkC.post("/signup/facebook", { api: 1, data });
	},
};



// WEBPACK FOOTER //
// ./src/apps/signup/util/web.js